export default __webpack_public_path__ + "static/media/air-export-dark.0ef242ac.svg";